<template>
	<li class="list-group-item px-0 py-3 lh-sm hstack gap-1">
		<div class="vstack">
			<div class="fw-bold link-dark">Contacto telefónico</div>
			<small class="d-block fw-normal">{{ phoneFormatted.nationalNumber }}</small>
		</div>
		<div class="hstack gap-4">
			<a :href="`tel:${phoneFormatted.number}`" class="fw-bold link-dark" @click="select({ type: 'phone', option: 'call' });"><i class="bi bi-telephone-plus text-md"></i></a>
			<a :href="`https://wa.me/${phoneFormatted.number}`" target="_blank" class="fw-bold link-dark" @click="select({ type: 'phone', option: 'whatsapp' });"><i class="bi bi-whatsapp text-md"></i></a>
		</div>
	</li>
</template>

<script>
	import { computed } from 'vue';
	import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

	export default {
		emits: ['select'],
		props: {
			value: String,
			country_code: String
		},
		setup(props, { emit }) {
			const phoneFormatted = computed(() => {
				if(isValidPhoneNumber(props.value, props?.country_code)) return parsePhoneNumber(props.value, props?.country_code);
				else return { number: props.value, nationalNumber: props.value };
			});

			const select = (type) => emit('select', type);

			return { phoneFormatted, select };
		}
	}
</script>